(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ea-discovery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ea-discovery]').forEach(section=>{const tabs=[...section.querySelectorAll('[role=tab]')];const activate=tab=>{tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',selected);item.tabIndex=selected?0:-1;document.getElementById(item.getAttribute('aria-controls')).hidden=!selected})};tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%tabs.length;if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;if(next!==undefined){event.preventDefault();activate(tabs[next]);tabs[next].focus()}})})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ea-faq-category"] && !Shopify.designMode) return;
  try {
    
(() => {
  const updateNavigation = () => {
    document.querySelectorAll('.ea-editable-faq-nav').forEach(nav => {
      nav.replaceChildren();
      document.querySelectorAll('.ea-editable-faq-topic').forEach(topic => {
        const heading = topic.querySelector('h2');
        if (!heading || !heading.textContent.trim()) return;
        const link = document.createElement('a');
        link.href = '#' + topic.id;
        link.textContent = heading.textContent;
        nav.append(link);
      });
      nav.hidden = !nav.children.length;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateNavigation);
  else updateNavigation();
  ['shopify:section:load','shopify:section:unload','shopify:section:reorder'].forEach(event => document.addEventListener(event, () => requestAnimationFrame(updateNavigation)));
  document.addEventListener('shopify:block:select', event => {
    const item = event.target.closest('.ea-editable-faq-item');
    if (item) item.open = true;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ea-header"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ea-header]').forEach(header=>{const breakpoint=window.matchMedia('(min-width:1100px)');const setMenu=()=>{header.querySelector('.ea-navigation').open=breakpoint.matches};setMenu();breakpoint.addEventListener('change',setMenu);header.addEventListener('keydown',event=>{if(event.key==='Escape'){const opened=[...header.querySelectorAll('details[open]')].reverse();if(opened[0]){opened[0].open=false;opened[0].querySelector('summary').focus()}}});document.addEventListener('click',event=>{if(!header.contains(event.target))header.querySelectorAll('details[open]').forEach(el=>{if(!el.classList.contains('ea-navigation')||!breakpoint.matches)el.open=false})});header.querySelectorAll('.ea-shop-menu,.ea-search').forEach(menu=>menu.addEventListener('toggle',()=>{if(menu.open)header.querySelectorAll('.ea-shop-menu,.ea-search').forEach(other=>{if(other!==menu)other.open=false})}));header.querySelector('.ea-search').addEventListener('toggle',event=>{if(event.target.open){header.querySelector('#EA-Search').focus();if(!breakpoint.matches)header.querySelector('.ea-navigation').open=false}})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ea-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ea-editorial-slides')) {
  customElements.define('ea-editorial-slides', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.dataset.autoplay === 'true' && !this.motion.matches;
      this.hovered = false;
      this.keyboardFocused = false;
      this.querySelector('.ea-slides-controls').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-play')) { this.playing = !this.playing; this.schedule(); return; }
        let next = null;
        if (button.hasAttribute('data-prev')) next = this.index - 1;
        if (button.hasAttribute('data-next')) next = this.index + 1;
        if (button.hasAttribute('data-index')) next = Number(button.dataset.index);
        if (next !== null) { this.show(next); }
      }, options);
      this.querySelector('.ea-slides-controls').addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
      this.querySelector('.ea-slides-controls').addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', event => { this.keyboardFocused = event.target.matches(':focus-visible'); this.schedule(); }, options);
      this.addEventListener('focusout', () => { this.keyboardFocused = false; this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.playing = false; this.schedule(); }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.playing = false; this.show(index); }
      }, options);
      this.schedule();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => {
        const active = position === this.index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.querySelectorAll('[data-index]').forEach((button, position) => {
        if (position === this.index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const button = this.querySelector('[data-play]');
      button.setAttribute('aria-label', this.playing ? button.dataset.pauseLabel : button.dataset.playLabel);
      button.firstElementChild.textContent = this.playing ? 'Ⅱ' : '▷';
      if (this.playing && !this.hovered && !this.keyboardFocused && !document.hidden && !this.motion.matches) this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 4000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ea-stones"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ea-stones]').forEach(section=>{const cards=[...section.querySelectorAll('[data-stone-name]')],input=section.querySelector('input'),buttons=[...section.querySelectorAll('[data-range]')];let range='all';const filter=()=>{const term=input.value.toLocaleLowerCase().trim();let count=0;cards.forEach(card=>{const name=card.dataset.stoneName;const match=range==='all'||(name[0]>=range[0]&&name[0]<=range[1]);card.hidden=!(match&&name.includes(term));if(!card.hidden)count++});section.querySelector('[data-stone-count]').textContent=count;section.querySelector('[data-stone-empty]').hidden=count>0;buttons.forEach(b=>b.setAttribute('aria-pressed',b.dataset.range===range))};input.addEventListener('input',()=>{range='all';filter()});buttons.forEach(b=>b.addEventListener('click',()=>{range=b.dataset.range;filter()}));section.querySelector('[data-stone-reset]').addEventListener('click',()=>{range='all';input.value='';filter();input.focus()});filter()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ea-styled-by-you"] && !Shopify.designMode) return;
  try {
    
if (!window.earthlyCommunityGalleryReady) {
  window.earthlyCommunityGalleryReady = true;
  const revealCommunityHeadings = function() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-writing');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.ea-community-gallery__header:not([data-reveal-ready])').forEach(function(header) {
      header.dataset.revealReady = 'true';
      observer.observe(header);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealCommunityHeadings, { once: true });
  else revealCommunityHeadings();
  document.addEventListener('shopify:section:load', revealCommunityHeadings);
  document.addEventListener('change', function(event) {
    if (!event.target.matches('.ea-look-form select, .ea-look-form input[type="radio"]')) return;
    const form = event.target.closest('form');
    const price = event.target.matches('select') ? event.target.selectedOptions[0].dataset.price : event.target.dataset.price;
    form.closest('.ea-look-piece').querySelector('.ea-community-gallery__price').textContent = price;
    const add = form.querySelector('.ea-look-add');
    add.textContent = add.dataset.label + ' · ' + price;
    form.querySelector('.ea-look-add').disabled = !event.target.value;
    form.querySelector('.ea-look-status').textContent = '';
  });
  document.addEventListener('submit', async function(event) {
    const form = event.target.closest('.ea-look-form');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const button = form.querySelector('.ea-look-add');
    const status = form.querySelector('.ea-look-status');
    const label = button.textContent;
    form.dataset.busy = 'true';
    button.disabled = true;
    button.textContent = form.dataset.loading;
    status.textContent = '';
    try {
      const body = new FormData(form);
      body.append('sections', 'cart-icon-bubble,cart-drawer');
      body.append('sections_url', window.location.pathname);
      const response = await fetch(form.action + '.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || form.dataset.error);
      status.textContent = form.dataset.added;
      if (result.sections && result.sections['cart-icon-bubble']) {
        const html = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
        const bubble = document.getElementById('cart-icon-bubble');
        const content = html.querySelector('.shopify-section');
        if (bubble && content) bubble.innerHTML = content.innerHTML;
      }
      if (result.sections && result.sections['cart-drawer']) {
        const html = new DOMParser().parseFromString(result.sections['cart-drawer'], 'text/html');
        const incoming = html.querySelector('#CartDrawer');
        const current = document.getElementById('CartDrawer');
        if (incoming && current) {
          current.innerHTML = incoming.innerHTML;
          current.closest('cart-drawer')?.classList.remove('is-empty');
        }
      }
    } catch (error) {
      status.textContent = error.message || form.dataset.error;
    } finally {
      form.dataset.busy = 'false';
      button.disabled = false;
      const selected = form.querySelector('input[type="radio"]:checked,select option:checked');
      button.textContent = selected ? button.dataset.label + ' · ' + selected.dataset.price : label;
    }
  });
  document.addEventListener('click', function(event) {
    const previewSummary = event.target.closest('.ea-look-preview > summary');
    if (previewSummary) {
      const dialog = previewSummary.closest('dialog');
      dialog.dataset.lookScroll = dialog.scrollTop;
      requestAnimationFrame(function() { dialog.scrollTop = 0; previewSummary.parentElement.querySelector('[data-look-collapse]').focus(); });
    }
    const collapse = event.target.closest('[data-look-collapse]');
    if (collapse) {
      const details = collapse.closest('details');
      details.open = false;
      details.querySelector('summary').focus({preventScroll:true});
      const dialog = details.closest('dialog');
      dialog.scrollTop = Number(dialog.dataset.lookScroll || 0);
      return;
    }
    const opener = event.target.closest('[data-look-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.lookOpen);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-look-close]');
    if (close) { close.closest('dialog').close(); return; }
    if (event.target.matches('.ea-community-gallery__dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    const pageLink = event.target.closest('.ea-community-gallery__pagination a');
    if (pageLink) pageLink.hash = pageLink.closest('.ea-community-gallery').id;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
